import { Text } from "@/atoms"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import {
  DeployCommand,
  type CommonDeployCommandProps
} from "@/pages/DeploymentsPage/components/molecules/DeployCommand"
import { DeploymentKeyButton } from "@/pages/DeploymentsPage/components/molecules/DeploymentKeyButton"
import { InlineInput } from "@/pages/DeploymentsPage/components/molecules/InlineInput"
import {
  getDefaultValues,
  getDeployCommand,
  getDeployCommandWindows,
  getInstallSuffixWindows,
  WINDOWS_INSTALLER_PREFIX,
  WINDOWS_INSTALLER_SUFFIX,
  WINDOWS_LINE_CONTINUATION
} from "./helpers"

import styles from "./VmDeployCommand.module.scss"

export const VmDeployCommand = (
  props: CommonDeployCommandProps & { isWindows?: boolean }
) => (
  <DeployCommand
    // DeployCommand also calls getDefaultValues() without props (copy text, reset),
    // so bind the tab's delimiter here or it falls back to "VM"
    getDefaultValues={(initialValues) =>
      getDefaultValues({
        ...initialValues,
        deploymentKeyDelimiter: props.deploymentKeyDelimiter
      })
    }
    getDeployCommand={
      props.isWindows ? getDeployCommandWindows : getDeployCommand
    }
    {...props}
  >
    {({ values, onChange, onError }) => {
      if (props.isWindows)
        return (
          <>
            <Text className={styles.stepText}>
              # Install Kodem kortex sensors
            </Text>
            <Text>
              {WINDOWS_INSTALLER_PREFIX}
              <InlineInput
                key={`${values.key}_pathKortexInstaller`}
                name="pathKortexInstaller"
                value={values.pathKortexInstaller}
                onChange={onChange}
              />
              {`${WINDOWS_INSTALLER_SUFFIX} ${WINDOWS_LINE_CONTINUATION}`}
            </Text>
            <Text>
              {"/ENV_NAME="}
              <InlineInput
                key={`${values.key}_environment`}
                name="environment"
                value={values.environment}
                onChange={onChange}
              />
              {` /ENV_TYPE=${values.deploymentKeyDelimiter} ${WINDOWS_LINE_CONTINUATION}`}
            </Text>
            <Text>
              {`/DEPLOYMENT_KEY=`}
              <InlineInput
                key={`${values.key}_deploymentKey`}
                name="deploymentKey"
                value={values.deploymentKey}
                onChange={onChange}
                buttons={<DeploymentKeyButton onError={onError} />}
              />
              {getInstallSuffixWindows(props.installSuffix)}
            </Text>
          </>
        )

      const selfHosted = isSelfHosted()

      return (
        <>
          <Text className={styles.redText}>
            cd
            <InlineInput
              key={`${values.key}_workDir`}
              name="workDir"
              value={values.workDir}
              onChange={onChange}
            />
          </Text>
          <Text className={styles.stepText}>
            # Unpack the tgz file at your workdir
          </Text>
          <Text>
            <Text className={styles.redText}>tar</Text>
            {` --no-overwrite-dir -xvf `}
            <InlineInput
              key={`${values.key}_pathKortexTGZ`}
              name="pathKortexTGZ"
              value={values.pathKortexTGZ}
              onChange={onChange}
            />
          </Text>
          <Text className={styles.stepText}>
            # Install Kodem kortex sensors
          </Text>
          <Text>
            <Text className={styles.redText}>sudo</Text>
            {` ./install_kortex.sh `}
            <InlineInput
              key={`${values.key}_environment`}
              name="environment"
              value={values.environment}
              onChange={onChange}
            />
            {values.deploymentKeyDelimiter && (
              <span>&nbsp;{values.deploymentKeyDelimiter}&nbsp;</span>
            )}
            {!values.deploymentKeyDelimiter && <span>&nbsp;</span>}
            <InlineInput
              key={`${values.key}_deploymentKey`}
              name="deploymentKey"
              value={values.deploymentKey}
              onChange={onChange}
              buttons={<DeploymentKeyButton onError={onError} />}
            />
            {(selfHosted || props.installSuffix) && <span>&nbsp;\</span>}
          </Text>
          {selfHosted && (
            <Text>
              &nbsp;&nbsp;KONTIGO=
              <InlineInput
                key={`${values.key}_kontigoUrl`}
                name="kontigoUrl"
                value={values.kontigoUrl}
                onChange={onChange}
              />
              {props.installSuffix && <span>&nbsp;\</span>}
            </Text>
          )}
          {props.installSuffix && (
            <Text>&nbsp;&nbsp;{props.installSuffix}</Text>
          )}
          <Text>
            <Text className={styles.redText}>sudo</Text>
            {` systemctl start kolibri koltan `}
          </Text>
          <Text className={styles.stepText}># Clean</Text>
          <Text>
            <Text className={styles.redText}>rm</Text>
            <Text
              className={styles.valueText}
            >{` ${values.pathKortexTGZ}`}</Text>
          </Text>
        </>
      )
    }}
  </DeployCommand>
)
